import { render, staticRenderFns } from "./ButtonIcon.vue?vue&type=template&id=a5f0a338&scoped=true&"
import script from "./ButtonIcon.vue?vue&type=script&lang=ts&"
export * from "./ButtonIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonIcon.vue?vue&type=style&index=0&id=a5f0a338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f0a338",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VMenu,VTooltip})
